import React, { forwardRef } from "react";
import { TextInput, ActionIcon } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

// A TextInput with a right-justified "x" button that clears it, shown only
// once there's something to clear. Shared by Search's query box and both of
// Browse's filter boxes (matters list, folder contents).
const ClearableTextInput = forwardRef(({ value, onClear, ...props }, ref) => (
	<TextInput
		ref={ref}
		value={value}
		rightSection={
			value ? (
				<ActionIcon
					variant="subtle"
					size="sm"
					title="Clear"
					onClick={onClear}
				>
					<IconX size={14} />
				</ActionIcon>
			) : null
		}
		{...props}
	/>
));

ClearableTextInput.displayName = "ClearableTextInput";

export default ClearableTextInput;
